import { useState } from 'react';
import { IconDown, IconInfo, IconUp } from '@ui/src';
import { ExpandableTypes } from './types';

import cn from './styles.module.css';

const Expandable = ({ children }: ExpandableTypes): React.JSX.Element => {
  const [expanded, setExpanded] = useState(true);

  return (
    <div className={cn.expandable}>
      <button
        className={cn.expandableTop}
        onClick={() => setExpanded((prev) => !prev)}
        type="button"
      >
        <IconInfo className={cn.expandableIcon} />
        <div className={cn.expandableTitle}>
          All users have basic access, regardless of role
        </div>

        {expanded ? <IconUp /> : <IconDown />}
      </button>
      {expanded && children && (
        <div className={cn.expandableWrapper}>{children}</div>
      )}
    </div>
  );
};

export default Expandable;
